import React from "react";
import ApiService from "../../../services/ApiService";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Spinner, Dropdown, Alert, Card } from "react-bootstrap";
import AccordionChallengesType from "../../../components/challenges/AccordionChallengesType";
import ChallengesTypeModal from "../../../components/challenges/ChallengesTypeModal";
import { store } from "../../../reducer/Store";
const ChallengesType = () => {
  const { dispatch, state } = React.useContext(store);
  const [showAddChallengeType, setShowAddChallengeType] = React.useState(false);
  const [showUpdateChallengeType, setShowUpdateChallengeType] =
    React.useState(false);
  const [challengeType, setChallengeType] = React.useState({
    name: "",
    color: "#000000",
    brand_id: "",
    year_id: "",
  });
  const [challengeIdType, setChallengeTypeId] = React.useState("");
  const [brand, setBrand] = React.useState([]);
  const [errorMessage, setErrorMessage] = React.useState("");

  const handleShowAdd = () => setShowAddChallengeType(true);
  /**
   * Cette fonction est appelée lorsque l'utilisateur souhaite modifier un type de challenge existant. Elle met à jour l'état de l'application pour afficher le formulaire de mise à jour du challenge correspondant.
   * @param {Object} chalType - Les informations du type de challenge à modifier.
   */
  const handleShowUpdate = (chalType) => {
    setChallengeType({
      name: chalType.name,
      color: chalType.color,
      brand_id: chalType.brand_id,
      year_id: chalType.brand_id,
    });
    var tab = [];
    state.listBrands.filter((brand) =>
      brand.value === chalType.brand_id.toString() ? tab.push(brand) : ""
    );
    setBrand(tab);
    setChallengeTypeId(chalType.id);
    setShowUpdateChallengeType(true);
  };

  const handleClose = () => {
    setErrorMessage("");
    setChallengeType({
      name: "",
      color: "#000000",
      brand_id: "",
      year_id: "",
    });
    setBrand([]);
    setShowUpdateChallengeType(false);
    setShowAddChallengeType(false);
  };
  /**
   * Cette fonction récupère tous les types de défis pour les marques sélectionnées et l'année en cours de l'utilisateur connecté.
   * Elle utilise l'API pour envoyer une requête GET avec les paramètres correspondants et met à jour le state de l'application avec les données récupérées.
   * En cas d'erreur, elle affiche un message dans la console et met également à jour le state avec un indicateur de chargement à false.
   */
  const getAllChallengesType = async () => {
    var brands = [];
    JSON.parse(localStorage.getItem("currentBrands")).map((brand) =>
      brands.push(brand.value)
    );
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `challenge-types-by-brand-year/${brands}/${
        JSON.parse(localStorage.getItem("currentYear")).value
      }`,
      "get"
    )
      .then(function (response) {
        dispatch({ type: "SET_CHALLENGESTYPE", payload: response.data });
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        console.log(error);
        dispatch({ type: "SET_LOADER", payload: false });
      });
  };

  /**
   * Cette fonction ajoute un nouveau type de challenge pour une marque et une année données.
   * @param { Object } e - L'événement de soumission du formulaire.
   * @param { Number } brand - L'identifiant de la marque associée au type de challenge.
   * @param { Object } state - L'état global de l'application.
   * @param { Object } challengeType - Les informations sur le type de challenge à ajouter (nom et couleur).
   * @param { Number } year_id - L'année à laquelle rattacher le Challenge.
   */
  const addChallengeType = async (e) => {
    e.preventDefault();
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        brand_id: brand.value,
        year_id: state.currentYear.value,
        name: challengeType.name,
        color: challengeType.color,
      },
      "challenge-types",
      "post"
    )
      .then(function (response) {
        dispatch({
          type: "SET_CHALLENGESTYPE",
          payload: response.data,
        });
        handleClose();
        dispatch({ type: "SET_LOADER", payload: false });
        getAllChallengesType();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message.includes("already exists")) {
          setErrorMessage("Ce nom existe déjà");
        }
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction met à jour un type de challenge pour tous les clients de l'application ou seulement pour certains, en fonction de la valeur du paramètre typePlvByDefault.
   * @param { Number } typePlvByDefault - Indique si le type de PLV doit être ajouté à tous les clients de l'application ou seulement à certains. Si la valeur est 1, le type de PLV est ajouté à tous les clients, sinon il est ajouté seulement pour le client en cours.
   * @param { Object } challengeType - L'objet contenant les informations du type de challenge à mettre à jour.
   * @param { String } challengeIdType - L'identifiant unique du type de challenge à mettre à jour.
   * @param { Number } year_id - L'année à laquelle rattacher le Challenge.
   * @param { Number } challengeIdType - L'identifiant unique du type de challenge à mettre à jour.
   */
  const updateChallengeType = async (e) => {
    e.preventDefault();
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        brand_id: challengeType.brand_id,
        year_id: challengeType.year_id,
        name: challengeType.name,
        color: challengeType.color,
      },
      "challenge-types/" + challengeIdType,
      "put"
    )
      .then(function (response) {
        dispatch({
          type: "SET_CHALLENGESTYPE",
          payload: response.data,
        });
        handleClose();
        dispatch({ type: "SET_LOADER", payload: false });
        getAllChallengesType();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (
          error.response.data.message.includes(
            "a atteint le quota de challenges maximales"
          )
        ) {
          console.log(error.response.data.message);
          setErrorMessage(error.response.data.message);
        } else if (error.response.data.message.includes("already exists")) {
          setErrorMessage("Ce nom existe déjà");
        }
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction permet de supprimer un challenge en fonction de son identifiant et demande une confirmation de l'utilisateur avant de le supprimer de manière définitive.
   * @param { Number } challId - L'identifiant du challenge à supprimer.
   */
  const deleteChallengeType = async (challId) => {
    if (
      window.confirm(
        "Voulez vous vraiment supprimer ce challenge ? Cela est définitif."
      )
    ) {
      ApiService.request({}, "challenge-types/" + challId, "delete")
        .then(function () {
          getAllChallengesType();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  /**
   * Cette fonction est appelée lorsqu'un champ de formulaire dans la fenêtre modale d'ajout ou de modification de type de challenge est modifié. Elle met à jour l'état du challengeType avec la nouvelle valeur du champ.
   * @param {Event} e - L'événement associé au changement de valeur dans un champ de saisie.
   * @param { String } field - Le nom du champ de formulaire qui a été modifié.
   */
  const handleChallengeTypeChange = (e, field) => {
    setChallengeType((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  /**
   * Cette fonction met à jour les informations d'un type de challenge dans l'état local.
   * @param {Event} e - L'événement associé au changement de valeur dans un champ de saisie.
   * @param {String} field - Le nom du champ à mettre à jour dans le state de l'application.
   */
  const handleChallengeTypeChangeUpdate = (e, field) => {
    setChallengeType((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  React.useEffect(() => {
    if (state.currentBrands.length > 0) {
      getAllChallengesType();
    } else {
      dispatch({
        type: "SET_CHALLENGESTYPE",
        payload: [],
      });
    }
  }, [state.currentYear, state.currentBrands]);

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <h1>
            Challenges
            <Dropdown className="d-inline-block">
              <Dropdown.Toggle>
                <MoreVertIcon />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    if (state.currentBrands.length === 1) {
                      setBrand(state.currentBrands[0]);
                    }
                    handleShowAdd();
                  }}
                  disabled={state.currentBrands.length === 0 ? true : false}
                >
                  <AddCircleOutlineOutlinedIcon /> Ajouter
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </h1>
        </div>
      </div>

      {showAddChallengeType && (
        <ChallengesTypeModal
          show={showAddChallengeType}
          handleClose={handleClose}
          handleShow={handleClose}
          errorMessage={errorMessage}
          action={"Ajouter Challenge"}
          addOrUpdateChallengeType={addChallengeType}
          challengeType={challengeType}
          handleChallengeTypeChange={handleChallengeTypeChange}
          setBrand={setBrand}
          valueBrand={brand}
          brandList={state.currentBrands}
        />
      )}
      {showUpdateChallengeType && (
        <ChallengesTypeModal
          show={showUpdateChallengeType}
          handleClose={handleClose}
          handleShow={handleClose}
          errorMessage={errorMessage}
          action={"Modifier Challenge"}
          addOrUpdateChallengeType={updateChallengeType}
          challengeType={challengeType}
          handleChallengeTypeChange={handleChallengeTypeChangeUpdate}
          setBrand={setBrand}
          valueBrand={brand}
          brandList={state.listBrands.slice(1)}
        />
      )}
      {state.currentBrands.length > 0 ? (
        !state.loader &&
        state.challengesType &&
        state.challengesType.length >= 0 ? (
          state.challengesType.map((challengeT, i) => (
            <AccordionChallengesType
              key={i}
              keyProp={i}
              challengeType={challengeT}
              deleteChallengeType={deleteChallengeType}
              handleShowUpdate={handleShowUpdate}
            />
          ))
        ) : state.loader ? (
          <div className="text-center pt-5">
            <Spinner animation="border" role="status"></Spinner>
          </div>
        ) : (
          <Card className="text-center">
            <Card.Body>
              <Alert variant="info" className="m-0">
                La liste est vide.
              </Alert>
            </Card.Body>
          </Card>
        )
      ) : (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Veuillez sélectionner au moins une marque.
            </Alert>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default ChallengesType;
